<template>
  <div class="footer">
    <div class="top">
      <div class="qrcode">
        <el-image style="width: 140px; height: 140px; margin-bottom: 4px" :src="qrcode" fit="fit"></el-image>
        <div>官方微信公众号</div>
      </div>
      <div class="list">
        <div class="list-item">
          <div>关于我们</div>
          <div @click="$router.push('/about')">联系我们</div>
          <div @click="$router.push('/join')">加入我们</div>
        </div>
        <div class="list-item">
          <div>官方微信公众号</div>
          <el-image style="width: 140px; height: 140px" :src="qrcode" fit="fit"></el-image>
          <!-- <el-popover placement="top-start" trigger="hover">
            <el-image style="width: 140px; height: 140px" :src="qrcode" fit="fit"></el-image>
            <div slot="reference">官方微信</div>
          </el-popover> -->
        </div>
      </div>
      <div class="contact">
        <div>
          <i class="el-icon-phone-outline"></i>
          服务热线（周一至周五 09:00-18:00）
        </div>
        <div class="phone">400-XXX-XXX</div>
        <div class="phone">0571-XXXXXXXX</div>
      </div>
    </div>
    <div class="bottom">
      <span>
        &copy; Copyright 贾维思科技
        <a href="https://beian.miit.gov.cn">浙ICP备XXXXXXXX号</a>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',

  mixins: [],

  components: {},

  props: {},

  data() {
    return {
      qrcode: require('@/assets/images/qrcode.jpg'),
    }
  },

  computed: {},

  watch: {},

  created() {},

  mounted() {},

  destroyed() {},

  methods: {},
}
</script>

<style lang="less" scoped>
@media screen and (max-width: 430px) {
  .qrcode {
    .el-image {
      width: 100px !important;
      height: 100px !important;
    }
  }
  .contact {
    div:nth-child(1) {
      font-size: 13px !important;
    }
  }
}

@media screen and (max-width: 768px) {
  .footer {
    padding: 30px 4% !important;

    .qrcode {
      display: block !important;
    }
    .list {
      display: none !important;
    }

    .bottom {
      margin-top: 50px !important;
      font-size: 12px !important;
    }
  }
}
.footer {
  width: 100%;
  padding: 30px 15%;
  box-sizing: border-box;
  background: #444444;
  text-align: center;
  color: #666;
  font-size: 14px;

  .top {
    display: flex;
    justify-content: space-between;
    height: 100px;

    .qrcode {
      display: none;
    }

    .list {
      display: flex;

      .list-item {
        margin-right: 4vw;
        font-size: 13px;
        line-height: 21px;
        text-align: left;
        cursor: pointer;

        & > div:first-child {
          color: #bfbfbf;
          margin-bottom: 12px;
          cursor: text;
        }
      }
    }

    .contact {
      color: #fff;
      text-align: right;

      div {
        margin-bottom: 20px;
      }

      .phone {
        font-size: 26px;
        font-weight: normal;
        font-family: Arial, Helvetica, sans-serif;
        font-style: italic;
        color: #bfbfbf;
        text-shadow: 0 -1px 1px rgb(0 0 0 / 20%), 0 1px 2px rgb(255 255 255 / 20%);
        margin-top: 4px;
        margin-bottom: 0;
      }
    }
  }

  .bottom {
    font-size: 15px;
    font-weight: 300;
    padding: 30px 0 20px;

    a {
      color: #999;
    }
  }
}
</style>
